import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
// import { thunk } from "redux-thunk";
import { loginReducer } from "../redux/reducers/LoginReducer";
import { dataReducer } from "../redux/reducers/DataReducer";
import { filterReducer } from "../redux/reducers/FilterReducer";
import { settingsReducer } from "../redux/reducers/SettingsReducer";
import { messageReducer } from "../redux/reducers/MessageReducer";
import { recoveryReducer } from "../redux/reducers/RecoveryReducer";
import { createLogger } from "redux-logger";

const rootReducer = combineReducers({
  loginState: loginReducer,
  dataState: dataReducer,
  filterState: filterReducer,
  settingsState: settingsReducer,
  messageState: messageReducer,
  recoveryState: recoveryReducer,
});

const logger = createLogger();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      process.env.NODE_ENV !== "production" ? logger : []
    ),
});
